// React
import React from "react";
import { Link } from "react-router-dom";

// Material
import { Fab } from "@material-ui/core";

// Icons
import { ArrowForward } from "@material-ui/icons";

import { useStyles } from "./NextActivity";
import { ActivityPath } from "../../models/activity.model";

interface INextActivityBtnProps {
  nextActivity?: ActivityPath;
  opts?: {
    shadow?: boolean;
    background?: boolean;
  };
}

const NextActivityBtn = (props: INextActivityBtnProps) => {
  /** Classes  */
  const classes = useStyles();

  /** Props */
  const { nextActivity } = props;

  const opts = Object.assign({ shadow: true, background: true }, props.opts);

  return (
    <Fab
      component={Link}
      to={window.location.pathname.replace(
        /(quiz|lesson)\/.+/,
        (nextActivity?.type ?? "") + "/" + (nextActivity?._id ?? "")
      )}
      variant="extended"
      size="large"
      color="primary"
      className={`
        ${classes.button} 
        ${!opts.shadow ? classes.noShadow : ""}
        ${!opts.background ? classes.noBackground : ""}
      `}
      disabled={!nextActivity}
    >
      Activité suivante&nbsp; <ArrowForward />
    </Fab>
  );
};

export default NextActivityBtn;
